// extracted by mini-css-extract-plugin
module.exports = {"container":"featured-integrations_container__nxR4G","header":"featured-integrations_header__XCnyC"};